import type { ResolvedRemovalOrder } from "../types/removal";
import {
  readResolveRequired,
  resolveTaxableFromSources,
} from "../utils/readResolveTaxable";

/**
 * Overlay POST /removal_orders financial fields from last resolve response.
 */
export function overlayRemovalSubmitFromResolved(
  payload: Record<string, unknown>,
  resolved: ResolvedRemovalOrder | null | undefined
): Record<string, unknown> {
  if (!resolved) return payload;

  const out = { ...payload };

  if (resolved.subtotal_amount != null) out.subtotal_amount = resolved.subtotal_amount;
  if (resolved.total_amount != null) out.total_amount = resolved.total_amount;
  if (resolved.removal_cost != null) out.removal_cost = resolved.removal_cost;
  if (resolved.additional_cost != null) out.additional_cost = resolved.additional_cost;
  if (resolved.discount_amount != null) out.discount_amount = resolved.discount_amount;
  if (resolved.discount_code != null) out.discount_code = resolved.discount_code;
  if (resolved.removal_tax_amount != null) out.removal_tax_amount = resolved.removal_tax_amount;
  if (resolved.removal_tax_percentage != null) {
    out.removal_tax_percentage = resolved.removal_tax_percentage;
  }
  if (resolved.over_all_tax_amount != null) out.over_all_tax_amount = resolved.over_all_tax_amount;
  if (resolved.over_all_tax_percentage != null) {
    out.over_all_tax_percentage = resolved.over_all_tax_percentage;
  }
  if (resolved.tax_status != null) out.tax_status = resolved.tax_status;
  if (resolved.cart_id) out.cart_id = resolved.cart_id;

  if (Array.isArray(resolved.specialfee) && resolved.specialfee.length > 0) {
    const originalById = new Map(
      (Array.isArray(out.specialfee) ? (out.specialfee as Record<string, unknown>[]) : []).map(
        (f) => [String(f.specialfee_id ?? f.id ?? ""), f]
      )
    );
    out.specialfee = resolved.specialfee.map((f) => {
      const id = String(f.specialfee_id || "");
      const original = originalById.get(id);
      const taxable = resolveTaxableFromSources(
        [original, f as Record<string, unknown>],
        ["specialfee_taxable", "taxable", "is_taxable"],
        true
      );
      return {
        specialfee_id: id,
        specialfee_name: String(f.specialfee_name || ""),
        specialfee_amount: Number(f.specialfee_amount || 0),
        specialfee_tax_percentage: Number(f.specialfee_tax_percentage || 0),
        specialfee_tax_amount: Number(f.specialfee_tax_amount || 0),
        specialfee_taxable: taxable,
        required: readResolveRequired(original) || f.required === true,
      };
    });
  }

  return out;
}
